module.exports = __webpack_public_path__ + "img/16.bbea8900.png";